import mixpanel from 'mixpanel-browser';
import { useTracking } from 'react-tracking';

mixpanel.init(window.REACT_APP_CONFIG?.REACT_APP_TELEMETRY_TOKEN as string || process.env.REACT_APP_TELEMETRY_TOKEN, { debug: true });

const telemetry_enabled = window.REACT_APP_CONFIG?.REACT_APP_TELEMETRY_ENABLED || process.env.REACT_APP_TELEMETRY_ENABLED;

class Telemetry {
    public static async trackEvent(data: any) {
        if (telemetry_enabled === 'false') {
            return;
        }

        const d = data.data;
        const a = this.getAnalytics();
        if (d.action) {
            a.track(d.action, d);
        } else if (d.identity) {
            a.identify(d.identity);
        } else {
            a.track(data.page);
        }
    }

    public static configure<T = {}>(page: string, template: T): [{}, {}] {
        return [
            {
                page,
                data: template,
            },
            {
                dispatch: (data: T) => {
                    Telemetry.trackEvent(data);
                },
                dispatchOnMount: true,
            },
        ];
    }

    private static getAnalytics() {
        return (window as { [key: string]: any }).analytics as any;
    }
}

const useTelemetry = <T extends object>(page: string, template: T) =>
    useTracking(...Telemetry.configure(page, template));

export default Telemetry;
export { useTelemetry };
